import { render, staticRenderFns } from "./prescription-draft-list-dialog.vue?vue&type=template&id=7fd4e1b2&scoped=true&lang=pug&"
import script from "./prescription-draft-list-dialog.vue?vue&type=script&lang=ts&"
export * from "./prescription-draft-list-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd4e1b2",
  null
  
)

export default component.exports